<template>
  <div class="layout" @wheel="handleWheel">
    <transition
      name="my-animated-nav animate__bounce"
      enter-active-class="animate__fadeInDown"
      leave-active-class="animate__fadeOutUp">
      <tiger-nav class="tiger-nav" v-show="!hideNav"/>
    </transition>
    <tiger-main/>
    <tiger-footer/>
  </div>
</template>

<script>
import {TigerNav, TigerMain, TigerFooter} from './components';

export default {
  name: "Layout",

  components: {TigerNav, TigerMain, TigerFooter},

  data() {
    return {
      hideNav: false
    }
  },

  methods: {
    handleWheel(e) {
      const scrollY = e.deltaY;
      this.hideNav = scrollY > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  width: 100vw;
  min-width: 960px;
  max-width: 2560px;
}

.tiger-nav {
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue